import { Observable } from 'rxjs';
import { IAuthToken } from '../../models';

export abstract class TokenRefreshHandler {
  /** Attempt to refresh the access token. Returns the new token or throws. */
  abstract refreshAccessToken(): Promise<IAuthToken>;

  /** Whether a refresh is currently in progress. */
  abstract isRefreshing(): boolean;

  /** Observable that emits once when an in-progress refresh completes (or errors). */
  abstract onRefreshComplete(): Observable<IAuthToken>;

  /**
   * Emits the new auth token every time a refresh succeeds. Unlike
   * {@link onRefreshComplete}, this is a long-lived stream meant for consumers
   * that must react to every rotation (e.g. pushing the fresh token into the
   * long-lived IDA chatbot WebView, which fires no app requests of its own).
   */
  abstract readonly tokenRefreshed$: Observable<IAuthToken>;

  /** Whether the current access token is expired or about to expire within bufferSeconds. */
  abstract isAccessTokenExpired(bufferSeconds?: number): boolean;
}
